import { frameSizeForImage } from './placementMetrics'
import { ImageElement, TemplateElement } from '../templateEditor.types'
import { clampRectToCanvas } from '../templateEditor.utils'

type HydrateOptions = {
    /** Игнорировать уже известные naturalW/H и пересчитать размер кадра. */
    force?: boolean
    /** Сохранять центр элемента при смене размера кадра. */
    keepCenter?: boolean
    canvasW?: number
    canvasH?: number
    minElSize?: number
}

/** Подгружает naturalW/H изображения и подгоняет кадр, если размеры ещё дефолтные. */
export const hydrateImageNaturalSize = (
    element: ImageElement,
    onUpdate: (patch: Partial<ImageElement>) => void,
    options?: HydrateOptions
) => {
    if (!element.src) {
        return
    }

    if (!options?.force && element.naturalW && element.naturalH) {
        return
    }

    const img = new Image()
    img.onload = () => {
        const naturalW = img.naturalWidth || img.width
        const naturalH = img.naturalHeight || img.height
        if (!naturalW || !naturalH) {
            return
        }

        const frame = frameSizeForImage(naturalW, naturalH)
        const shouldResize =
            Boolean(options?.force) ||
            (!element.naturalW && !element.naturalH && Math.abs(element.w - 400) < 2 && Math.abs(element.h - 225) < 2)

        if (!shouldResize) {
            onUpdate({ naturalW, naturalH })
            return
        }

        if (options?.keepCenter && options.canvasW != null && options.canvasH != null) {
            const centerX = element.x + element.w / 2
            const centerY = element.y + element.h / 2
            const next = clampRectToCanvas(
                {
                    x: centerX - frame.w / 2,
                    y: centerY - frame.h / 2,
                    w: frame.w,
                    h: frame.h,
                },
                options.canvasW,
                options.canvasH,
                options.minElSize ?? 8
            )
            onUpdate({ naturalW, naturalH, ...next })
            return
        }

        onUpdate({
            naturalW,
            naturalH,
            w: frame.w,
            h: frame.h,
        })
    }
    img.src = element.src
}

export const isHydratableImage = (element: TemplateElement): element is ImageElement =>
    element.type === 'image' && Boolean(element.src) && (!element.naturalW || !element.naturalH)
